exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".loader{display:none;font-size:1.6em;text-align:center}.content---eE024{padding:10px}", ""]);

// exports
exports.locals = {
	"content": "content---eE024"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoaders=1&modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader!./~/sass-loader!./~/sass-resources-loader/lib/loader.js!./src/entry/views/loader/loader.scss
// module id = 1022
// module chunks = 0